import { useParams, useLocation, useNavigate } from 'react-router-dom';

const withRouter = Component => props => {
  const match = { params: useParams() };

  const location = useLocation();

  const navigate = useNavigate();

  const navigateWithPrevLocation = (to, ...otherProps) => {
    navigate(to, {
      ...otherProps,
      ...{
        state: {
          _prevLocation: {
            pathname: location?.pathname || '',
            search: location?.search || '',
            hash: location?.hash || '',
          },
        },
      },
    });
  };

  // we can add more stuff here and inject into passed component if we need in the future

  return (
    <Component
      {...props}
      {...{
        match,
        location,
        navigate: params => navigateWithPrevLocation(params),
      }}
    />
  );
};

export default withRouter;
